export default __webpack_public_path__ + "fonts/add-green.svg";